module.exports = __webpack_public_path__ + "img/home-hero_en-nohalo.587d1b0.jpg";